import {
  GET_ACCOUNTS_TYPE,
  GET_DOCUMENTS_TYPE,
  GET_MESSAGE_TYPE,
  GET_MODELS_TYPE,
  GET_RFC_TYPE,
  GET_ROLES_TYPE,
  GET_ROLE_TYPE,
} from "../actions/types";

const initialState = {
  accountsType: [],
  rolesType: [],
  messageType: [],
};

const accountTypeReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case GET_ACCOUNTS_TYPE:
      return {
        ...state,
        accountsType: payload,
      };
    case GET_ROLES_TYPE:
      return {
        ...state,
        rolesType: payload,
      };
    case GET_MESSAGE_TYPE:
      return {
        ...state,
        messageType: payload,
      };
    case GET_DOCUMENTS_TYPE:
      return {
        ...state,
        documentType: payload,
      };
    case GET_MODELS_TYPE:
      return {
        ...state,
        modelsType: payload,
      };
    case GET_RFC_TYPE:
      return {
        ...state,
        rfcType: payload,
      };
    case GET_ROLE_TYPE:
      return {
        ...state,
        role: payload,
      };
    default:
      return state;
  }
};

export default accountTypeReducer;
